import React, { useState } from 'react';
import { connect } from 'react-redux';
import { setSelectedPackage, reportDWH } from '../energySaleBlockSlice';
import {getOderPrice} from '../energySaleBlockAsyncThunk';
import SalePackages from '../../SalePackagesBlock/SalePackages';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { isOrgEmployeeLogin } from '../../OTPLoginBlock/Assets/variables';
import { getOrgFamilyBenefitsAllocations } from '../../../Page/OrgEmployeeFamilySalePage/OrgEmployeeFamilySaleSlice';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';

const PackagesPage = (props) => {
const [availablePackages, setAvailablePackages] = useState(props.packages);
const [title, setTitle] = useState(props.epiText.title);
const [subTitle, setSubTitle] = useState(props.epiText.subTitle);
const isOrgEmployeeFamily = isOrgEmployeeLogin(props._authentication);

  useExtendedEffect((runSideEffects) => {
    const resolvePackages = async () => {
      let packages = [];

      if (isOrgEmployeeFamily) {
        let productsDescription = props.benefitsAllocations || {};
        if (isNullOrEmpty(productsDescription)) {
          const result = await props.getOrgFamilyBenefitsAllocations();
          if (result?.payload) {
            productsDescription = result?.payload?.productsDescription || {};
          }
        }
        packages = productsDescription?.["energy"]?.salesPackages || [];
      } else if (props.iecResponse?.serviceMigratable) {
        packages = availablePackages?.expandedValue?.filter(p => (p.isSmartMeterPackage.value || p.isSuitableForAllMeterTypesPackage.value));
      } else {
        packages = availablePackages?.expandedValue?.filter(p => !p.isSmartMeterPackage.value);
        if (props.displayAlternativePackage) {
          setTitle(props.epiText.titleAlternativeNotSmartMeter);
          setSubTitle(props.epiText.subTitleAlternativeNotSmartMeter);
        }
      }

      setAvailablePackages({ expandedValue: packages });
    };

    resolvePackages();

    gtag4({
      event: 'Energy_Step5_PackagesImp',
      step: '5',
      action: 'PersonalInfoPage',
      funnel_name: 'Counter_Check',
    });

    if(props.displayAlternativePackage){
      props.reportDWH({ actionType: 'Change Package', status: 'Ongoing', messageText: 'Change Package for counter- Display' })
      gtag4({
        event: 'Energy_Step5_PackagesCarouselNoCounterImp',
        step: '5',
        action: 'PackagesCarouselNoCounterImp',
        funnel_name: 'Marketing_Page',
      });
    }
    else{
      props.reportDWH({ actionType: 'Energy Counter - Answer', status: 'Ongoing', messageText: 'Choose Package - Display' })
    }

    if (runSideEffects()) {
    }
  },
  [],);


  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='energy-sale-title' dangerouslySetInnerHTML={{__html: title}}></h1>
      <h2 className='energy-sale-sub-title' dangerouslySetInnerHTML={{__html: subTitle}}></h2>
    </div>
  );


  let currentPageView = (
    <SalePackages
      packages={availablePackages}
      orderType={props.orderType}
      onSelectedPackages={onSelectedPackages}
    />
  );

  return (
    <div className='energy-sale-content-wrapper'>
      {currentPageHeadline}
      <div className='energy-sale-page-content full-width'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
      </div>
    </div>
  );

  function onSelectedPackages(salePackage) {
    gtag4({
      event: 'Energy_Step5_PackagesClick',
      step: '5',
      button: salePackage.buttonText,
      package: salePackage.title,
      action: 'PackagesClick',
      funnel_name: 'Counter_Check',
    });
    const selectedPackage = {
      ...salePackage,
    };
    props.setSelectedPackage(selectedPackage);
    if(props.displayAlternativePackage){
      props.reportDWH({ actionType: 'Change Package', status: 'Ongoing', messageText: 'Change Package for counter- Click' });
      gtag4({
        event: 'Energy_Step5_PackagesCarouselNoCounterClick',
        step: '5',
        button: salePackage.buttonText,
        package: salePackage.title,
        action: 'PackagesCarouselNoCounterClick',
        funnel_name: 'Marketing_Page',
      });
    }else{
      props.reportDWH({ actionType: 'Energy Counter - Answer', status: 'Ongoing', messageText: 'Choose Package - Clicked' });
    }
    props.getOderPrice();
  }

  function handleSubmit(event) {
    event.preventDefault();
  }
};

const mapStateToProps = (state) => {
  return {
    orderType: state.energySaleBlock.orderType,
    iecResponse : state.energySaleBlock.iecResponse,
    packages: state.energySaleBlock.energySaleBlockData.packages,
    epiText: state.energySaleBlock.energySaleBlockData.epiText.packagesPage,
    displayAlternativePackage: state.energySaleBlock.displayAlternativePackage,
    _authentication: state.authentication,
    benefitsAllocations: state.orgEmployeeFamilySale.benefitsAllocations,
  };
};

const mapDispatchToProps = {
  setSelectedPackage,
  reportDWH,
  getOderPrice,
  getOrgFamilyBenefitsAllocations
};

export default connect(mapStateToProps, mapDispatchToProps)(PackagesPage);
